import type { HubCandidateFilters } from "./types";

/**
 * Build the query-param object for GET /candidates from the active filters (plus
 * optional paging). Keys are the backend's camelCase aliases. Empty/absent filters are omitted entirely so
 * the request carries only the dimensions the recruiter actually narrowed on, and `noInterviewer` is only
 * sent when true (the backend defaults it to false). Pure and side-effect-free so it can be unit-tested.
 */
export function buildHubCandidateParams(filters: HubCandidateFilters): Record<string, string | number | boolean | string[]> {
	const params: Record<string, string | number | boolean | string[]> = {};
	const departmentId = filters.departmentId?.trim();
	if (departmentId) params.departmentId = departmentId;
	// Repeatable `departmentIds` (serialized via query-string in the service layer). Empty entries are
	// dropped so an all-cleared multi-select sends nothing rather than a blank param.
	const departmentIds = filters.departmentIds?.map((id) => id.trim()).filter(Boolean);
	if (departmentIds && departmentIds.length > 0) params.departmentIds = departmentIds;
	if (filters.pipelineStatus) params.pipelineStatus = filters.pipelineStatus;
	const position = filters.position?.trim();
	if (position) params.position = position;
	const q = filters.q?.trim();
	if (q) params.q = q;
	if (filters.noInterviewer) params.noInterviewer = true;
	return params;
}
